import { BlogPostSimple } from 'types';

import styles from './BlogPage.module.scss';
import { NextLink } from 'components/NextLink';

export type RelatedArticlesProps = {
  articles: Array<BlogPostSimple>;
};

export const RelatedArticles = ({ articles }: RelatedArticlesProps) => {
  return (
    <div className={styles.relatedContainer}>
      <h2 className={styles.relatedTitle}>Related Articles</h2>

      <div className={styles.relatedArticlesContainer}>
        {articles.map(article => (
          <NextLink href={`/blog/${article.slug}`} className={styles.relatedArticle}>{article.title}</NextLink>
        ))}
      </div>
    </div>
  );
};
